import { FC, useState } from 'react';
import { StyledSampleTrackingCard } from './SampleTracking.styles';
import { SampleTrackingFilters } from './SampleTrackingFilter/SampleTrackingFilter.types';
import SampleTrackingFilter from './SampleTrackingFilter/SampleTrackingFilter';
import SampleTrackingTable from './SampleTrackingTable/SampleTrackingTable';
import { SubPage } from '@builder';
import { useQuerySampleTrackingStrategy, UseSampleTrackingRequest } from '@modules/study-insights/strategies';
import { PAGE_SIZE, SampleTrackingParams } from './SampleTracking.types';
import useOrganizationName from '@/modules/my-account/hooks/useOrganizationName';
import { PartnerOrganization } from '@/modules/core/types';

const SampleTracking: FC = () => {
  const [offset, setOffset] = useState<number>(0);
  const [params, setParams] = useState<SampleTrackingParams>({
    limit: PAGE_SIZE,
  });
  const organizationName = useOrganizationName();
  const props: UseSampleTrackingRequest = {
    partner: organizationName as PartnerOrganization,
    params: {
      offset: params.offset,
      limit: params.limit,
      start: params.from,
      end: params.to,
      status: params.status,
      sampleType: params.sampleType,
      collectionLocation: params.collectionLocation,
      query: params.query,
      sort: params.sort,
      retrospective: false,
    },
    options: {
      enabled: params?.selectedDateRange !== undefined,
    },
  };

  const { data, isLoading, isFetching, isError } = useQuerySampleTrackingStrategy(props);
  const handleFilterChange = ({ query, dateRange, statuses }: SampleTrackingFilters): void => {
    setParams({
      ...params,
      query,
      from: dateRange?.startDate,
      to: dateRange?.endDate,
      offset: 0,
      status: statuses,
      selectedDateRange: dateRange?.selectedDateRange,
    });
    setOffset(0);
  };

  const handleChangePage = (offset: number): void => {
    setParams({
      ...params,
      offset,
    });
    setOffset(offset);
  };

  const handleChangeSorting = (sort: Map<string, boolean>): void => {
    setParams({
      ...params,
      offset: 0,
      sort: Object.fromEntries(sort),
    });
    setOffset(0);
  };

  return (
    <SubPage>
      <StyledSampleTrackingCard>
        <SampleTrackingFilter onFilterChange={handleFilterChange} />
        <SampleTrackingTable
          data={data}
          isLoading={isLoading || isFetching}
          isError={isError}
          offset={offset}
          onChangePage={handleChangePage}
          onChangeSorting={handleChangeSorting}
        />
      </StyledSampleTrackingCard>
    </SubPage>
  );
};

export default SampleTracking;
